import { Component, inject, signal, computed, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogContent, MatDialogTitle } from "@angular/material/dialog";
import { MedicalScale } from "../entities/medical-scale";
import { MedicalScaleLevel } from "../entities/medical-scale-level";
import { CommonModule } from "@angular/common";
import { MatIconButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";

@Component({
	selector: "app-scale-viewer",
	imports: [CommonModule, MatDialogTitle, MatDialogContent, MatIconButton, MatDialogClose, MatIcon],
	templateUrl: "./scale-viewer.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: "./scale-viewer.component.scss",
})
export class ScaleViewerComponent {
	readonly data = inject<{ scale: MedicalScale }>(MAT_DIALOG_DATA);
	readonly selectedLevel = signal<MedicalScaleLevel | null>(null);

	readonly sortedLevels = computed(() => {
		return [...this.data.scale.levels].sort((a, b) => a.position - b.position);
	});

	selectLevel(level: MedicalScaleLevel): void {
		this.selectedLevel.set(level);
	}

	saveAssessment(): void {
		// To be implemented: save the assessment result
		console.log("Saving assessment", {
			scale: this.data.scale.label,
			level: this.selectedLevel()?.label,
		});
	}
}
